import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
const router = new Router({
  mode:"history",
  routes: [
        {
          path:"/",
          name: "home",
          // component: ()=>import("@/views/home.vue")
          component:  resolve =>require(["@/views/home/index.vue"], resolve),
        },
        // {//首页
        //   path: '/',
        //   name: 'Index',
        //   meta:{title:"登录"},
        //   component:  resolve =>require(["@/components/Index.vue"], resolve),
        //   children: [
        // ]
        // },
        // {//登录页
        //   path: '/',
        //   name: 'HelloWorld',
        //   meta:{title:"登录"},
        //   component:  resolve =>require(["@/components/HelloWorld.vue"], resolve),
        // },
        {
          path: '/seriesLesson',
          name: 'seriesLesson',
          meta:{title:"精品系列课"},
          component:  resolve =>require(["@/views/seriesLesson/index.vue"], resolve),
        },
        {
          path: '/seriesLessonSecond',
          name: 'seriesLessonSecond',
          meta:{title:"精品系列课"},
          component:  resolve =>require(["@/views/seriesLesson/Second.vue"], resolve),
        },
        {
          path: '/seriesLessonThird',
          name: 'seriesLessonThird',
          meta:{title:"精品系列课"},
          component:  resolve =>require(["@/views/seriesLesson/Third.vue"], resolve),
        },
        {
          path: '/goodLesson',
          name: 'goodLesson',
          meta:{title:"一堂好课"},
          component:  resolve =>require(["@/views/goodLesson/index.vue"], resolve),
        },
        // {
        //   path: '/goodLessonDetail',
        //   name: 'goodLessonDetail',
        //   meta:{title:"一堂好课"},
        //   component:  resolve =>require(["@/views/goodLesson/detail.vue"], resolve),
        // },
        {
          path: '/goodLessonSecond',
          name: 'goodLessonSecond',
          meta:{title:"一堂好课"},
          component:  resolve =>require(["@/views/goodLesson/goodLessonSecond.vue"], resolve),
        },
        {
          path: '/goodLessonWeeklyDetail',
          name: 'goodLessonWeeklyDetail',
          meta:{title:"一堂好课"},
          component:  resolve =>require(["@/views/goodLesson/weeklyDetail.vue"], resolve),
        },
        {
          path: '/hundred',
          name: 'hundred',
          meta:{title:"英才100分"},
          component:  resolve =>require(["@/views/hundred/index.vue"], resolve),
        },
        {
          path: '/hundredDetail',
          name: 'hundredDetail',
          meta:{title:"英才100分"},
          component:  resolve =>require(["@/views/hundred/detail.vue"], resolve),
        },
        {
          path: '/VIP',
          name: 'VIP',
          meta:{title:"英才VIP"},
          component:  resolve =>require(["@/views/vip/index.vue"], resolve),
        },
        {path: '/userCenter',
          name: 'userCenter',
          meta:{title:"个人中心"},
          component:  resolve =>require(["@/views/userCenter/index.vue"], resolve),
        },
        {path: '/contact',
          name: 'contact',
          meta:{title:"联系我们"},
          component:  resolve =>require(["@/views/userCenter/contact/index.vue"], resolve),
        },
        {path: '/feedback',
          name: 'feedback',
          meta:{title:"意见反馈"},
          component:  resolve =>require(["@/views/userCenter/feedback/index.vue"], resolve),
        },
        {path: '/myXueshi',
          name: 'myXueshi',
          meta:{title:"我的学时"},
          component:  resolve =>require(["@/views/userCenter/xueshiCenter/myXueshi.vue"], resolve),
        },
        {path: '/xueshiList',
          name: 'xueshiList',
          meta:{title:"学时记录"},
          component:  resolve =>require(["@/views/userCenter/xueshiCenter/xueshiList.vue"], resolve),
        },
        {path: '/myZhengshu',
          name: 'myZhengshu',
          meta:{title:"学时证书"},
          component:  resolve =>require(["@/views/userCenter/xueshiCenter/myZhengshu.vue"], resolve),
        },
        {path: '/integInfo',
          name: 'integInfo',
          meta:{title:"我的积分"},
          component:  resolve =>require(["@/views/userCenter/xueshiCenter/integInfo.vue"], resolve),
        },
        {path: '/address',
          name: 'address',
          meta:{title:"邮箱/地址"},
          component:  resolve =>require(["@/views/userCenter/xueshiCenter/address.vue"], resolve),
        },
        {path: '/addAddress',
          name: 'addAddress',
          meta:{title:"邮箱/地址"},
          component:  resolve =>require(["@/views/userCenter/xueshiCenter/addAddress.vue"], resolve),
        },
        {
          path: '/webLive',
          name: 'webLive',
          meta:{title:"直播"},
          component:  resolve =>require(["@/views/home/webLive.vue"], resolve),
        },
        {
          path: '/teacher',
          name: 'teacher',
          meta:{title:"导师"},
          component:  resolve =>require(["@/views/teacher/index.vue"], resolve),
        },
        {
          path: '/shop',
          name: 'shop',
          meta:{title:"心选商城"},
          component:  resolve =>require(["@/views/shop/index.vue"], resolve),
        },
        {
          path: '/goodsDetail',
          name: 'goodsDetail',
          meta:{title:"心选商城"},
          component:  resolve =>require(["@/views/shop/goodsDetail.vue"], resolve),
        },
        {
          path: '/addOrder',
          name: 'addOrder',
          meta:{title:"心选商城"},
          component:  resolve =>require(["@/views/shop/addOrder.vue"], resolve),
        },
        {
          path: '/order',
          name: 'order',
          meta:{title:"心选商城"},
          component:  resolve =>require(["@/views/shop/order.vue"], resolve),
        },
        {
          path: '/shopCart',
          name: 'shopCart',
          meta:{title:"心选商城"},
          component:  resolve =>require(["@/views/shop/shopCart.vue"], resolve),
        },
        {
          path: '/classList',
          name: 'classList',
          meta:{title:"心选商城"},
          component:  resolve =>require(["@/views/shop/classList.vue"], resolve),
        },
        {
          path: '/myInteg',
          name: 'myInteg',
          meta:{title:"心选商城"},
          component:  resolve =>require(["@/views/shop/myInteg.vue"], resolve),
        },
        {
          path: '/answer',
          name: 'answer',
          meta:{title:"答疑解惑"},
          component:  resolve =>require(["@/views/answer/index.vue"], resolve),
        },
        {
          path: '/answermy/:tab',
          name: 'answermy',
          meta:{title:"答疑解惑"},
          component:  resolve =>require(["@/views/answermy/index.vue"], resolve),
        },
        {
          path: '/search',
          name: 'search',
          meta:{title:"搜索结果"},
          component:  resolve =>require(["@/views/search/index.vue"], resolve),
        },
        {
          path: '/evaluation',
          name: 'evaluation',
          meta:{title:"课程评价"},
          component:  resolve =>require(["@/views/hundred/evaluation.vue"], resolve),
        },
        {
          path: '/editUserInfo',
          name: 'editUserInfo',
          meta:{title:"资料编辑"},
          component:  resolve =>require(["@/views/userCenter/editUserInfo.vue"], resolve),
        },
        {
          path: '/offlineClass',
          name: 'offlineClass',
          component: () => import('@/views/offlineClass/index'),
          meta: { title: '线下实战课' }
        },
        {
          path: '/scheduling',
          name: 'scheduling',
          component: () => import('@/views/offlineClass/scheduling'),
          meta: { title: '排期表' }
        },
        {
          path: '/offlineDetail',
          name: 'offlineDetail',
          component: () => import('@/views/offlineClass/offlineDetail'),
          meta: { title: '线下实战课' }
        },
        {
          path: '/offlineMyVip',
          name: 'offlineMyVip',
          component: () => import('@/views/offlineClass/myVip'),
          meta: { title: '我的会员' }
        },
        {
          path: '/offlineVipSystem',
          name: 'offlineVipSystem',
          component: () => import('@/views/offlineClass/vipSystem'),
          meta: { title: '我的会员' }
        },
        {
          path: '/liveBox',
          name: 'liveBox',
          component: () => import('@/views/liveBox/index'),
          meta: { title: '直播' }
        },

        
        
        
  ]
})

// router.beforeEach((to, from, next) => {
//   console.log('0000000',to, from,)
//   if(to.query.code){
//     console.log(1111111)
//     if(!store.state.loginInfo.Token){
//       // router.app.$store.commit('qrCodeLogin',to.query.code)
//       router.app.$options.store.commit('qrCodeLogin',to.query.code)
//     }
//   }
//   next();
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js